import { Link, useLocation } from "react-router-dom";
import { Landmark, ArrowUpRight } from "lucide-react";

export default function MobileActionBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-[#102036]/10 bg-[#FFFFFF]/90 p-3 backdrop-blur-xl md:hidden" data-testid="mobile-action-bar">
      <Link
        to="/client-centre"
        data-testid="mobile-bar-client-centre"
        className="inline-flex items-center justify-center gap-1.5 rounded-full bg-[#102036] px-4 py-3 text-[13px] font-bold uppercase tracking-[0.12em] text-white"
      >
        <Landmark className="h-4 w-4" /> Client Centre
      </Link>
      <Link
        to="/#contact"
        data-testid="mobile-bar-contact"
        className="inline-flex items-center justify-center gap-1.5 rounded-full border border-[#102036]/20 bg-white px-4 py-3 text-[13px] font-bold uppercase tracking-[0.12em] text-[#102036]"
      >
        Contact <ArrowUpRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
